module.exports = __webpack_public_path__ + "static/media/Complete_Map.eb335a3f.png";